import axios from '@/libs/api.request'

export const getDispatchinfolist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/dispatchinfo/dispatchinfo/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationDispatchinfo = (data, meth) => {
  return axios.request({
    url: '/v1/dispatchinfo/dispatchinfo/',
    method: meth,
    data
  })
}
